import { types } from 'mobx-state-tree';

export const ConfirmationTextsModel = types.model('ConfirmationTextsModel', {
  diggingPermit: types.maybe(types.string),
  leasehold: types.maybe(types.string),
  taPlan: types.maybe(types.string),
  signUp: types.maybe(types.string)
});
